import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

// Every public route ships as pre-rendered HTML (scripts/prerender/build.js).
// When that markup is present AND belongs to the requested path (the inline
// guard sets data-prerender-fallback="1" and empties #root otherwise), we
// HYDRATE it instead of re-rendering from scratch: React adopts the existing
// DOM, the text already on screen is never repainted (LCP = first paint, no
// layout shift) and lazy Suspense boundaries keep their server HTML until the
// chunk arrives. If anything does not match, React recovers by re-rendering
// the affected boundary on the client (same result as before, just logged).
const isPrerendered =
  container.hasChildNodes() &&
  container.getAttribute("data-prerendered") === "1" &&
  document.documentElement.getAttribute("data-prerender-fallback") !== "1";

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (isPrerendered) {
  ReactDOM.hydrateRoot(container, app, {
    onRecoverableError: (err, info) => {
      // eslint-disable-next-line no-console
      console.warn("[hydration] recovered:", err && err.message, info && info.componentStack);
    },
  });
} else {
  ReactDOM.createRoot(container).render(app);
}
